import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import colors from '../../foundations/colors.module.scss';
import styles from './TableList.module.scss';
export const TableListSortIcons = (props)=>/*#__PURE__*/ _jsxs("svg", {
        width: "8",
        height: "12",
        viewBox: "0 0 8 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: styles.sortIcons,
        children: [
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.75 1.70857e-07C4.05152 0.00144835 4.33636 0.132013 4.52568 0.355555L6.98103 3.18889L6.98103 3.18889C7.27376 3.53691 7.33261 4.01344 7.13266 4.41667C6.97034 4.76747 6.60777 4.99554 6.20535 5L1.29465 5V5C0.892225 4.99554 0.529662 4.76747 0.367335 4.41667L0.367335 4.41667C0.167389 4.01344 0.226243 3.53691 0.518972 3.18889L2.97432 0.355556C3.16364 0.132013 3.44848 0.0014483 3.75 1.70857e-07Z",
                fill: props.sort === 'asc' ? colors.dark900 : colors.dark300
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.75 12V12C3.44848 11.9986 3.16364 11.868 2.97432 11.6444L0.518973 8.81111L0.518973 8.81111C0.226243 8.46309 0.167389 7.98656 0.367336 7.58333V7.58333C0.529663 7.23253 0.892225 7.00446 1.29465 7H6.20535V7C6.60777 7.00446 6.97034 7.23253 7.13266 7.58333V7.58333C7.33261 7.98656 7.27376 8.46309 6.98103 8.81111L4.52568 11.6444V11.6444C4.33636 11.868 4.05152 11.9986 3.75 12V12Z",
                fill: props.sort === 'desc' ? colors.dark900 : colors.dark300
            })
        ]
    });
